// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100vh;
  background-color: #0560cf;
}

.invert {
  transform: rotate(180deg) !important;
}

ion-content {
  background: url("/assets/bg/bg-iibbweb.svg") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  text-align: center;
}
@media only screen and (max-width: 600px) {
  ion-content {
    background: url("/assets/bg/bg-iibb.svg") !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    text-align: center;
  }
}
ion-content .container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
ion-content .btn {
  position: absolute;
  bottom: 34px;
  width: 100%;
  padding: 0 35%;
}
@media only screen and (max-width: 600px) {
  ion-content .btn {
    padding: 0 20%;
  }
}
ion-content span.bold {
  font-weight: 600;
  font-size: 16px;
}

.no-internet-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.cat-icon {
  width: 150px;
  margin-bottom: 20px;
}

.no-internet-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.no-internet-text {
  font-size: 1rem;
  color: #555;
  margin-bottom: 20px;
}

ion-button {
  --border-radius: 10px;
  font-size: 1.2rem;
}

.help-icon {
  font-size: 16px;
  margin-left: 5px;
  color: var(--ion-color-primary);
  cursor: pointer;
}

.tooltip {
  position: absolute;
  top: 0;
  background: #f8f9fb;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-size: 12px;
  z-index: 200;
  padding: 0px 5px;
  padding-left: 200px;
  padding-right: 200px;
}
@media only screen and (max-width: 600px) {
  .tooltip {
    padding-left: 5px;
    padding-right: 5px;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AACA;EACE,uDAAA;EACA,uCAAA;EACA,iCAAA;EACA,kBAAA;AAEF;AADE;EALF;IAMI,oDAAA;IACA,uCAAA;IACA,iCAAA;IACA,kBAAA;EAIF;AACF;AAFE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAIJ;AADE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAGJ;AAFI;EALF;IAMI,cAAA;EAKJ;AACF;AAFE;EACE,gBAAA;EACA,eAAA;AAIJ;;AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAGF;;AAAA;EACE,YAAA;EACA,mBAAA;AAGF;;AAAA;EACE,iBAAA;EACA,iBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAGF;;AAAA;EACE,qBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAGF;;AAAA;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAGF;AAFE;EAZF;IAaI,iBAAA;IACA,kBAAA;EAKF;AACF;AACA,4zHAA4zH","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  height: 100vh;\n  background-color: #0560cf;\n}\n\n.invert {\n  transform: rotate(180deg) !important;\n}\nion-content {\n  background: url('/assets/bg/bg-iibbweb.svg') !important;\n  background-repeat: no-repeat !important;\n  background-size: cover !important;\n  text-align: center;\n  @media only screen and (max-width: 600px) {\n    background: url('/assets/bg/bg-iibb.svg') !important;\n    background-repeat: no-repeat !important;\n    background-size: cover !important;\n    text-align: center;\n  }\n\n  .container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .btn {\n    position: absolute;\n    bottom: 34px;\n    width: 100%;\n    padding: 0 35%;\n    @media only screen and (max-width: 600px) {\n      padding: 0 20%;\n    }\n  }\n\n  span.bold {\n    font-weight: 600;\n    font-size: 16px;\n  }\n}\n\n.no-internet-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  text-align: center;\n}\n\n.cat-icon {\n  width: 150px;\n  margin-bottom: 20px;\n}\n\n.no-internet-title {\n  font-size: 1.5rem;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.no-internet-text {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 20px;\n}\n\nion-button {\n  --border-radius: 10px;\n  font-size: 1.2rem;\n}\n\n.help-icon {\n  font-size: 16px;\n  margin-left: 5px;\n  color: var(--ion-color-primary);\n  cursor: pointer;\n}\n\n.tooltip {\n  position: absolute;\n  top: 0;\n  background: #f8f9fb;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  font-size: 12px;\n  z-index: 200;\n  padding: 0px 5px;\n  padding-left: 200px;\n  padding-right: 200px;\n  @media only screen and (max-width: 600px) {\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
